import React, { useEffect, useState } from 'react';
import { Field, change, reduxForm, getFormValues } from 'redux-form';
import { API_URL } from '@Utils/config';
import { connect, useSelector } from 'react-redux';
import {
  FLAG_URL,
  HUNDRED_THOUSAND,
  DEBOUNCE_PERIOD,
  APPROVED,
  V_KYC_STATUS_PENDING
} from '@Utils/constants';
import Image from 'semantic-ui-react/dist/commonjs/elements/Image';
import {
  formatCurrencyAmount,
  parseCurrency,
  formatCurrencyToTwoDecimalPlaces
} from '@Utils/library';
import { TextField, CommonDropdown, CommonButton, ModalFactory } from '@Components';
import { greaterThanZero, requiredWithoutZero, normalizeCurrency } from '@Utils/validation';
import {
  niumForexTransactionComputation,
  createNiumForexTempTransaction,
  changeNiumForexScreen,
  getPendingTransaction,
  getSourceOfFunds,
  getReasonForTransfer,
  getStudentOptions,
  storeTransactionIdAction
} from '@Redux/actions/nium-forex';
import { getNiumForexTransactionHistory } from '@Redux/actions/transaction-history';
import {
  INFO_GREY_ICON,
  CLOSE_POPUP_ICON,
  CURRENT_LOCATION_PIN_ICON,
  INFO_NEW_ICON
} from '@Images';
import { debounce } from '@Utils/debounce';
import DetailsModal from './details';
import TransferRelatedInformation from './transfer-related-information';
import {
  ScreenContainer,
  FormContainer,
  MainContainer,
  CurrencyCalculator,
  NormalHorizonatlLine,
  DetailsContainer,
  DetailsContainerRight,
  DetailsContainerLeft,
  CurrencyCalculatorWrapper,
  LineBreakLight,
  DetailsText,
  TextGrey,
  YouPayExactlyFinalAmountText,
  Header,
  Heading,
  PendingKYCModalContainer,
  SWIFTChargesContainer,
  SwiftCharges,
  InfoIcon
} from './style';
import { activateLoader, disableLoader, scrollToError } from '@Redux/actions/ui-trigger';
import {
  SEND_MONEY_CALCULATOR_SCREEN,
  NIUM_FOREX_CALCULATOR_FORM,
  COMPUTE_API_ERROR_MESSAGES
} from '../../utils/constants';
import IncludesFees from './send-money-fees/index';
import Popup from 'semantic-ui-react/dist/commonjs/modules/Popup';
import {
  ISendMoneyScreen,
  ISendMoneyState,
  ISendMoneyPayload,
  TransactionData,
  IObject
} from '../../utils/interface';
import AdditionalInfo from './additional-info';
import ResponsiveStepComponent from './send-money-header/index';
import InProgressTransaction from './in-progress-transaction';
import { FLOW_TYPE_SEND_MONEY } from '@Utils/constants/eventsConstants';
import { IStore } from '../../../../store.type';
import { preparePayload, getFirstValue } from './utils';
import { NF_SCREENS } from '../../root/screenConstants';
import CancelExistingTransferModal from './in-complete-transaction/index';
import { DisclaimerInfo } from '../../styles';
import NFCustomInfoCarouselCard from '../../components/NFCustomInfoCard';
import Carousel from '../../../../components/Slider/Carousel';
import { CrossSellingBannerContainer } from '../cross-selling/styles';
import { getContentForCrossSelling, logUserEventForNFCrossSelling } from '../cross-selling/utils';
import { EventNames, LOG_TYPE } from '../../../../utils/events/eventsConstants';
import { selectNiumForexReducer } from '../../../../redux/selectors';
import { logEvent } from '../../../../utils/events/logUserEvents';

const NiumForexSendMoneyCalculator: React.FC<ISendMoneyScreen> = (props) => {
  const {
    dispatch,
    createNiumForexTempTransaction,
    status,
    handleSubmit,
    activateLoader,
    disableLoader,
    getPendingTransaction,
    getSourceOfFunds,
    getReasonForTransfer,
    getStudentOptions,
    getAllformVal,
    form,
    getNiumForexTransactionHistory,
    video_kyc_status,
    nfCrossSellBanner
  } = props;

  const [state, setState] = useState<ISendMoneyState>({
    computedData: {},
    transactionDetails: {
      transaction_fee_amount: 0,
      sourceCurrency: '',
      payment_method_fee_amount: 0,
      payout_method_fee_amount: 0,
      instarem_fx_rate: 0
    },
    netTaxAmount: 0,
    net_of_fee_amount: 0,
    transaction_fee_amount: 0,
    payment_method_fee_amount: 0,
    payout_method_fee_amount: 0,
    instarem_fx_rate: 0,
    sourceAmount: props?.sourceAmount,
    destination_amount: props?.destination_amount || 0,
    netSourceAmount: 0,
    isVideoKycCompletedFlag: status === APPROVED,
    sourceOfFunds: getAllformVal?.sourceOfFunds,
    reasonForTransfer: getAllformVal?.reasonForTransfer,
    remittanceType: getAllformVal?.remittanceType,
    remittanceTypeCode: getAllformVal?.remittanceTypeCode,
    sourceErr: '',
    selectedReasonForTransferCode: getAllformVal?.selectedReasonForTransferCode
  });

  const [activeTransaction, setActiveTransaction] = useState<TransactionData | null>(null);
  const [isTransactionInProgressFlag, setIsActiveTransactionInProgress] = useState<boolean>(false);
  const [sourceOfFundsOptions, setSourceOfFundsOptions] = useState<IObject[]>([]);
  const [reasonForTransferOptions, setReasonForTransferOptions] = useState<IObject[]>([]);
  const [studentOptions, setStudentOptions] = useState<IObject[]>([]);
  const [isNewTransactionRestricted, setIsNewTransactionRestricted] = useState<boolean>(false);

  const { youSend, setUpNewTransfer, details, youPayExactly, recipientReceives } =
    SEND_MONEY_CALCULATOR_SCREEN;

  const reKycRequired = useSelector(selectNiumForexReducer)?.userDetails?.rekyc_required;

  const handleProceedToOngoingTransaction = () => {
    if (activeTransaction?.length) {
      const screenName = activeTransaction ? activeTransaction[0].screen_name : null;
      if (screenName && activeTransaction) {
        dispatch(storeTransactionIdAction(activeTransaction[0]?.transaction_id));
        dispatch(changeNiumForexScreen(screenName));
      }
    }
  };

  const logEvents = () => {
    const ctData = {
      pageName: FLOW_TYPE_SEND_MONEY,
      youSend: props?.sourceAmount,
      recipientReceives: props?.destination_amount,
      sourceOfFunds: state.sourceOfFunds,
      reasonForTransfer: state.reasonForTransfer
    };
    logEvent('nf_setup_transfer', FLOW_TYPE_SEND_MONEY, ctData, LOG_TYPE.CLEVER_TAP);
  };

  const showWarning = async () => {
    // @ts-ignore
    const response = await ModalFactory.builder?.(
      (onClose: any) => (
        <CancelExistingTransferModal
          onContinue={() => onClose(true)}
          onConfirm={() => {
            onClose(false);
          }}
        />
      ),
      'center-modal insta-modal',
      true
    );
    if (response) {
      initiateTransaction();
    }
  };

  const initiateTransaction = async () => {
    if (state?.sourceErr === '') {
      activateLoader();
      const payload: ISendMoneyPayload = preparePayload(state.computedData);
      payload.source_currency = getAllformVal?.sourceCurrency;
      payload.destination_currency = getAllformVal?.destinationCurrency;
      payload.source_of_funds = getAllformVal.sourceOfFunds;
      payload.reason_for_transfer = getAllformVal.reasonForTransfer;
      if (getAllformVal?.remittanceType) {
        payload.remittance_type = getAllformVal.remittanceType;
      } else {
        delete payload.remittance_type;
      }
      if (getAllformVal?.remittanceTypeCode) {
        payload.remittance_type_code = getAllformVal.remittanceTypeCode;
      }
      const response = await createNiumForexTempTransaction(
        payload,
        getAllformVal?.selectedReasonForTransferCode
      );
      // @ts-ignore
      if (response?.data?.success) {
        logEvents();
        dispatch(changeNiumForexScreen(NF_SCREENS.recipient));
      }
      disableLoader();
    }
  };

  const handleSetUpNewTransfer = async () => {
    if (isNewTransactionRestricted) {
      handlePendingVKYC();
      return;
    }
    if (activeTransaction?.length) {
      showWarning();
    } else {
      await initiateTransaction();
    }
  };

  const handleFieldChange = (
    amount: number,
    name: string,
    receiving_currency: string,
    formValues: Record<string, any>
  ) => {
    getComputedCurrency(amount, name, receiving_currency, formValues);
  };

  const myDebounce = (
    value = HUNDRED_THOUSAND,
    name: string,
    receiving_currency: string,
    formValues: Record<string, any>
  ) => {
    handleFieldChange(value, name, receiving_currency, formValues);
  };

  //eslint-disable react-hooks/exhaustive-deps
  const debounceOnChange = debounce(DEBOUNCE_PERIOD, myDebounce);

  const handleChange = async (name: string, value: number) => {
    await dispatch(change(NIUM_FOREX_CALCULATOR_FORM, name, value));
  };

  const formatAmount = (value: number) => parseCurrency(value?.toString());

  const getComputedCurrency = async (
    amount: number,
    type: string,
    receiving_currency: string | null,
    formValues: Record<string, any>
  ) => {
    activateLoader();
    let computedData = null;
    const params: Record<string, any> = {
      source_currency: formValues?.sourceCurrency || 'INR',
      destination_currency: receiving_currency || formValues?.destinationCurrency || 'USD',
      transfer_type: SEND_MONEY_CALCULATOR_SCREEN?.bankTransfer,
      source_amount: amount ? formatAmount(amount) : HUNDRED_THOUSAND,
      source_of_funds: formValues?.sourceOfFunds,
      reason_for_transfer: formValues?.reasonForTransfer,
      remittance_type: formValues?.remittanceType !== 0 ? formValues?.remittanceType : null,
      country_code: 'IN'
    };
    if (params?.destination_currency && params?.reason_for_transfer && params?.source_of_funds) {
      // Case when user changes the destination amount
      if (type === 'Destination') {
        delete params.source_amount;
        params.destination_amount = formatAmount(amount);
      }
      if (params?.source_amount || params?.destination_amount > 0) {
        const response = await niumForexTransactionComputation(params);
        if (response) {
          if (typeof response === 'string' && COMPUTE_API_ERROR_MESSAGES.includes(response)) {
            params.source_amount = HUNDRED_THOUSAND;
            delete params.destination_amount;
            computedData = await niumForexTransactionComputation(params);
            dispatch(change(form, 'destination_amount', computedData?.destination_amount));
          } else {
            computedData = response;
          }
          const {
            net_tax_amount,
            instarem_fx_rate,
            net_of_fee_amount,
            transaction_fee_amount,
            payment_method_fee_amount,
            payout_method_fee_amount
          } = computedData;
          if (type === 'Destination')
            dispatch(
              change(NIUM_FOREX_CALCULATOR_FORM, 'sourceAmount', computedData?.gross_source_amount)
            );
          else {
            dispatch(change(form, 'destination_amount', computedData?.destination_amount));
          }
          setState({
            ...state,
            computedData: computedData,
            netTaxAmount: net_tax_amount,
            net_of_fee_amount: net_of_fee_amount,
            transaction_fee_amount: transaction_fee_amount,
            payment_method_fee_amount: payment_method_fee_amount,
            payout_method_fee_amount: payout_method_fee_amount,
            instarem_fx_rate: instarem_fx_rate,
            sourceAmount: formatAmount(computedData?.gross_source_amount),
            netSourceAmount: computedData?.net_source_amount,
            sourceErr: computedData?.source_validation,
            sourceOfFunds: state.sourceOfFunds,
            reasonForTransfer: state.reasonForTransfer,
            selectedReasonForTransferCode: state.selectedReasonForTransferCode,
            destination_amount: formatAmount(computedData?.destination_amount)
          });
        }
      }
    }
    disableLoader();
  };

  const handleShowDetails = async () => {
    // @ts-ignore
    return await ModalFactory.builder?.(
      (onClose: any) => (
        <DetailsModal
          sourceAmount={state?.sourceAmount || 0}
          destinationAmount={state?.destination_amount || 0}
          sourceCurrency={getAllformVal?.sourceCurrency}
          destinationCurrency={getAllformVal?.destinationCurrency}
          transactionFeeAmount={state?.transaction_fee_amount}
          computedData={state?.computedData}
          instarem_fx_rate={state?.instarem_fx_rate}
          netSourceAmount={state?.netSourceAmount}
          handleCloseDetailsModal={() => onClose(true)}
        />
      ),
      'nium-forex send-money-details insta-modal center-modal',
      true
    );
  };

  const handleGetTransactionHistory = async () => {
    activateLoader();
    const response: any = await getPendingTransaction();
    if (response?.data?.length) {
      setActiveTransaction(response.data);
      setIsActiveTransactionInProgress(true);
    }
    disableLoader();
  };

  const handleGetDropdownValues = async () => {
    try {
      const [sourceOfFundsResponse, reasonForTransferResponse, studentResponse]: any =
        await Promise.all([getSourceOfFunds(), getReasonForTransfer(), getStudentOptions()]);
      setSourceOfFundsOptions(sourceOfFundsResponse?.data || []);
      setReasonForTransferOptions(reasonForTransferResponse?.data || []);
      setStudentOptions(studentResponse?.data || []);
      dispatch(
        change(
          form,
          'sourceOfFunds',
          props?.initialValues?.sourceOfFunds || getFirstValue(sourceOfFundsResponse?.data)
        )
      );
      dispatch(
        change(
          form,
          'reasonForTransfer',
          props?.initialValues?.reasonForTransfer || getFirstValue(reasonForTransferResponse?.data)
        )
      );
      if (reasonForTransferResponse?.data) {
        const reasonForTransferTemp =
          props?.initialValues?.reasonForTransfer || getFirstValue(reasonForTransferResponse.data);
        const initialReasonForTransfer: Array<IObject> = reasonForTransferResponse.data.filter(
          (item: IObject) => item?.value === reasonForTransferTemp
        );
        if (initialReasonForTransfer?.length > 0) {
          dispatch(
            change(form, 'selectedReasonForTransferCode', initialReasonForTransfer[0]?.code)
          );
        }
      }
      if (props?.initialValues?.remittanceType)
        dispatch(change(form, 'remittanceType', props.initialValues.remittanceType));
      //@ts-ignore
      getComputedCurrency(getAllformVal?.sourceAmount, '', null, getAllformVal);
    } catch (error) {
      setSourceOfFundsOptions([]);
      setReasonForTransferOptions([]);
      setStudentOptions([]);
    }
  };

  const getCreatedTransactionHistory = async () => {
    activateLoader();
    const response = await getNiumForexTransactionHistory(null, 0, null, null, null, true);
    if (response?.isNewTransactionRestricted) {
      setIsNewTransactionRestricted(response?.isNewTransactionRestricted);
      await handlePendingVKYC();
    }
    disableLoader();
  };

  const redirectToVKYC = (onClose: (value: boolean) => void) => {
    onClose(false);
    dispatch(changeNiumForexScreen(NF_SCREENS.video_kyc));
  };

  const handleInfoCardClick = () => {
    logUserEventForNFCrossSelling({
      eventName: EventNames.NF_CROSS_SELLING.discovery,
      pageName: 'send_money'
    });
    dispatch(changeNiumForexScreen(NF_SCREENS.cross_selling));
  };

  const handlePendingVKYC = async () => {
    //@ts-ignore
    return await ModalFactory.builder?.(
      (onClose: any) => (
        <PendingKYCModalContainer>
          <div className="heading-icon-container">
            <span className="__heading">
              {SEND_MONEY_CALCULATOR_SCREEN?.vKYCPendingModal?.modalHeading}
            </span>
            <img
              src={CLOSE_POPUP_ICON}
              onClick={() => onClose(false)}
              className="close-icon"
              alt="close"
            />
          </div>
          <div className="modal-body-container">
            <span className="__sub-heading">
              {SEND_MONEY_CALCULATOR_SCREEN?.vKYCPendingModal?.modalSubHeading}
            </span>
          </div>
          <CommonButton
            text={SEND_MONEY_CALCULATOR_SCREEN?.vKYCPendingModal?.btnText}
            width={418}
            onClick={() => redirectToVKYC(onClose)}
          />
        </PendingKYCModalContainer>
      ),
      'nium-forex send-money-details insta-modal center-modal',
      true
    );
  };

  useEffect(() => {
    activateLoader();
    if (getAllformVal?.sourceOfFunds && getAllformVal?.reasonForTransfer) {
      // @ts-ignore
      getComputedCurrency(getAllformVal?.sourceAmount, '', null, getAllformVal);
    }
    //eslint-disable-next-line
  }, [getAllformVal?.destinationCurrency]);

  useEffect(() => {
    handleGetTransactionHistory();
    handleGetDropdownValues();
    getCreatedTransactionHistory();
    getContentForCrossSelling(dispatch);

    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    setState({
      ...state,
      sourceAmount: getAllformVal?.sourceAmount,
      sourceOfFunds: getAllformVal?.sourceOfFunds,
      reasonForTransfer: getAllformVal?.reasonForTransfer,
      remittanceType: getAllformVal?.remittanceType,
      remittanceTypeCode: getAllformVal?.remittanceTypeCode,
      selectedReasonForTransferCode: getAllformVal?.selectedReasonForTransferCode
    });

    const callComputeAPIFlag = getAllformVal?.sourceOfFunds && getAllformVal?.reasonForTransfer;

    if (callComputeAPIFlag) {
      // @ts-ignore
      getComputedCurrency(getAllformVal?.sourceAmount, '', null, getAllformVal);
    }

    //eslint-disable-next-line
  }, [getAllformVal?.sourceOfFunds, getAllformVal?.reasonForTransfer]);

  const showKycInfo = video_kyc_status === V_KYC_STATUS_PENDING || reKycRequired;

  return (
    <div>
      <CrossSellingBannerContainer>
        <Carousel>
          {isTransactionInProgressFlag && activeTransaction?.length && (
            <InProgressTransaction
              proceedToTransaction={handleProceedToOngoingTransaction}
              activeTransaction={activeTransaction}
            />
          )}
          <ScreenContainer>
            <NFCustomInfoCarouselCard
              icon={nfCrossSellBanner.icon}
              heading={nfCrossSellBanner.title}
              subHeading={nfCrossSellBanner.description}
              handleOnClick={handleInfoCardClick}
            />
          </ScreenContainer>
        </Carousel>
      </CrossSellingBannerContainer>

      <Header marginTop={activeTransaction?.length ? '0px' : '24px'}>
        <Heading> {SEND_MONEY_CALCULATOR_SCREEN?.heading}</Heading>
        <ResponsiveStepComponent isVideoKycCompleted={state.isVideoKycCompletedFlag} />
      </Header>
      <ScreenContainer>
        <FormContainer>
          <form onSubmit={handleSubmit(handleSetUpNewTransfer)}>
            <MainContainer>
              <CurrencyCalculatorWrapper>
                <CurrencyCalculator>
                  <TextGrey>{youSend}</TextGrey>

                  <div className="parent">
                    <div className="childFirst">
                      <div className={'currencyField'}>
                        <Field
                          key={1}
                          bindToThisObject={getAllformVal?.sourceAmount}
                          name="sourceAmount"
                          component={TextField}
                          errFromParent={state?.sourceErr}
                          validate={[requiredWithoutZero, greaterThanZero]}
                          normalize={normalizeCurrency}
                          disableUnderlineStyling={true}
                          format={formatCurrencyAmount}
                          defaultValue={HUNDRED_THOUSAND}
                          parse={parseCurrency}
                          dependedOnObject={state.sourceAmount}
                          maxLength={12}
                          onChange={(e: any) => {
                            debounceOnChange(
                              e.target.value,
                              e.target.name,
                              getAllformVal?.destinationCurrency,
                              getAllformVal
                            );
                          }}
                        />
                      </div>
                    </div>
                    <div className="parentflags">
                      <div className="child">
                        <div className="flagImage">
                          <Image
                            src={`${FLAG_URL}${
                              getAllformVal?.sourceCurrency || 'INR'
                            }.png`.toLocaleLowerCase()}
                            height="24"
                            width="24"
                          />
                        </div>
                      </div>
                      <div className="child">
                        <Field
                          bindToThisObject={getAllformVal?.sourceCurrency}
                          name="source_currency"
                          component={CommonDropdown}
                          onDropdownChange={(event: any) => {
                            handleChange('sourceCurrency', event?.value);
                          }}
                          className="dropdown-component"
                          fluid={true}
                          dependedOnObject={getAllformVal?.sourceCurrency}
                          normalize={normalizeCurrency}
                          url={`${API_URL}/public/remitter/currencies/dropdown`}
                          showImage={true}
                          disabled={true}
                        />
                      </div>
                    </div>
                  </div>
                  <div>
                    <div>
                      <span className="feesInclude">
                        {`Includes fee ${Number(state?.transaction_fee_amount).toLocaleString(
                          'en'
                        )} ${getAllformVal?.sourceCurrency || 'INR'} `}
                        <Popup
                          trigger={
                            <img
                              alt="more-info"
                              width={'20px'}
                              src={INFO_GREY_ICON}
                              className="includeFees"
                            />
                          }
                          size="tiny"
                          content={
                            <IncludesFees
                              txnFees={state?.transaction_fee_amount}
                              bankTransferFee={state?.payment_method_fee_amount}
                              rcvFees={state?.payout_method_fee_amount}
                              sourceCurrency={getAllformVal?.sourceCurrency || 'INR'}
                            />
                          }
                        />
                      </span>
                    </div>
                  </div>
                  <div className="conversionRate">
                    <NormalHorizonatlLine />
                  </div>
                  <TextGrey>{recipientReceives}</TextGrey>
                  <div className="parent">
                    <div className="childFirst">
                      <div className={'currencyField'}>
                        <Field
                          key={1}
                          bindToThisObject={getAllformVal?.destination_amount}
                          name="destination_amount"
                          format={formatCurrencyAmount}
                          component={TextField}
                          validate={[requiredWithoutZero, greaterThanZero]}
                          parse={parseCurrency}
                          dependedOnObject={state.destination_amount}
                          onChange={(e: any) =>
                            debounceOnChange(
                              e.target.value,
                              'Destination',
                              props.destinationCurrency,
                              getAllformVal
                            )
                          }
                          normalize={normalizeCurrency}
                          disableUnderlineStyling={true}
                          maxLength={12}
                        />
                      </div>
                    </div>
                    <div className="parentflags">
                      <div className="child">
                        <div className="flagImage">
                          <Image
                            src={`${FLAG_URL}${getAllformVal?.destinationCurrency}.png`.toLocaleLowerCase()}
                            height="24"
                            width="24"
                          />
                        </div>
                      </div>
                      <div className="child">
                        <Field
                          bindToThisObject={getAllformVal?.destinationCurrency}
                          name="source_currency"
                          component={CommonDropdown}
                          onDropdownChange={(event: any) => {
                            handleChange('destinationCurrency', event?.value);
                          }}
                          className="dropdown-component"
                          fluid={true}
                          dependedOnObject={getAllformVal?.destinationCurrency}
                          url={`${API_URL}/public/remitter/currencies/dropdown?country_code=IN&source_currency=INR`}
                          showImage={true}
                        />
                      </div>
                    </div>
                  </div>

                  <p className="conversionText">
                    {`@1${getAllformVal?.sourceCurrency} = ${state.instarem_fx_rate} ${getAllformVal?.destinationCurrency}`}
                  </p>
                </CurrencyCalculator>
              </CurrencyCalculatorWrapper>
              <SWIFTChargesContainer>
                <InfoIcon src={INFO_NEW_ICON} alt="info-icon" />
                <SwiftCharges>{SEND_MONEY_CALCULATOR_SCREEN?.swiftCharges}</SwiftCharges>
              </SWIFTChargesContainer>
              <TransferRelatedInformation
                state={state}
                setState={setState}
                getAllformVal={getAllformVal}
                dispatch={dispatch}
                form={form}
                sourceOfFundsOptions={sourceOfFundsOptions}
                reasonForTransferOptions={reasonForTransferOptions}
                studentOptions={studentOptions}
              />
              <LineBreakLight className="marginLineBreak" />
              <AdditionalInfo
                netTaxAmount={formatCurrencyAmount(
                  formatCurrencyToTwoDecimalPlaces(state.netTaxAmount)
                )}
                currency={getAllformVal?.sourceCurrency}
              />
              <LineBreakLight className="marginLineBreak" />
              <DetailsContainer margin={[24, 0, 48, 0]}>
                <DetailsContainerLeft>
                  <TextGrey>{youPayExactly}</TextGrey>
                  <YouPayExactlyFinalAmountText>
                    {formatCurrencyAmount(
                      formatCurrencyToTwoDecimalPlaces(state?.netSourceAmount)
                    ) +
                      ' ' +
                      getAllformVal?.sourceCurrency}
                  </YouPayExactlyFinalAmountText>
                </DetailsContainerLeft>
                <DetailsContainerRight>
                  <DetailsText onClick={handleShowDetails}>{details}</DetailsText>
                </DetailsContainerRight>
              </DetailsContainer>
              {showKycInfo && (
                <>
                  <LineBreakLight className="marginLineBreak" />
                  <DisclaimerInfo margin={[0, 0, 48, 0]}>
                    <div className="image">
                      <img alt="location" src={CURRENT_LOCATION_PIN_ICON} />
                      <div className="disclaimerInfo">
                        {reKycRequired && (
                          <p className="info vkyc-info">
                            {SEND_MONEY_CALCULATOR_SCREEN.vkycRenewalMessage}
                          </p>
                        )}
                        <p className="info">
                          <strong className="bold">
                            {SEND_MONEY_CALCULATOR_SCREEN.disclaimerInfo?.mustBeInIndia}
                          </strong>
                          {SEND_MONEY_CALCULATOR_SCREEN?.disclaimerInfo?.locationDisclaimer}
                        </p>
                      </div>
                    </div>
                  </DisclaimerInfo>
                </>
              )}
              <CommonButton text={setUpNewTransfer} width={450} />
            </MainContainer>
          </form>
        </FormContainer>
      </ScreenContainer>
    </div>
  );
};

const createReduxForm = reduxForm({
  form: NIUM_FOREX_CALCULATOR_FORM,
  onSubmitFail: scrollToError
});

function mapStateToProps(reduxState: IStore) {
  const getAllformVal = getFormValues(NIUM_FOREX_CALCULATOR_FORM)(reduxState);
  const {
    rootReducer: {
      niumForexReducer: {
        niumForexCrossSelling: {
          components: { nf_cross_sell_discovery_banner: nfCrossSellBanner }
        },
        transactionDetails: {
          sourceAmount,
          sourceCurrency,
          destinationCurrency,
          destinationAmount,
          sourceOfFunds,
          reasonForTransfer,
          remittanceType,
          selectedReasonForTransferCode,
          remittanceTypeCode
        },
        userDetails: { status, video_kyc_status }
      }
    }
  } = reduxState;

  return {
    niumForexTransactionComputation,
    createNiumForexTempTransaction,
    initialValues: {
      sourceAmount: sourceAmount || HUNDRED_THOUSAND,
      sourceCurrency: sourceCurrency || 'INR',
      destinationCurrency: destinationCurrency || 'USD',
      destination_amount: destinationAmount || 0,
      sourceOfFunds: sourceOfFunds,
      reasonForTransfer: reasonForTransfer,
      remittanceType: remittanceType,
      selectedReasonForTransferCode: selectedReasonForTransferCode,
      remittanceTypeCode
    },
    getAllformVal,
    status,
    video_kyc_status,
    nfCrossSellBanner
  };
}
const ReduxFormNiumForexSendMoneyCalculator = createReduxForm(NiumForexSendMoneyCalculator);

export default connect(mapStateToProps, {
  activateLoader,
  disableLoader,
  createNiumForexTempTransaction,
  getPendingTransaction,
  getSourceOfFunds,
  getReasonForTransfer,
  getStudentOptions,
  getNiumForexTransactionHistory
})(ReduxFormNiumForexSendMoneyCalculator);
